import { MonotonicTimeSource_getInstance3kd0beqz5hu3i as MonotonicTimeSource_getInstance } from './MonoTimeSource.mjs';
import {
  Duration__unaryMinus_impl_x2k1y036zdiljvbimse as Duration__unaryMinus_impl_x2k1y0,
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  Duration__compareTo_impl_pchp0f1efu9z6fxx84c as Duration__compareTo_impl_pchp0f,
} from './Duration.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ValueTimeMark___init__impl__uyfl2m(reading) {
  return reading;
}
function _ValueTimeMark___get_reading__impl__5qz8rd($this) {
  return $this;
}
function ValueTimeMark__elapsedNow_impl_eonqvs($this) {
  return MonotonicTimeSource_getInstance().elapsedFrom_6e5kl0_k$($this);
}
function ValueTimeMark__minus_impl_f87sko($this, duration) {
  return MonotonicTimeSource_getInstance().adjustReading_m6y62h_k$($this, Duration__unaryMinus_impl_x2k1y0(duration));
}
function ValueTimeMark__minus_impl_f87sko_0($this, other) {
  if (!(other instanceof ValueTimeMark()))
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Subtracting or comparing time marks from different time sources is not possible: ' + ValueTimeMark__toString_impl_ow3ax6($this) + ' and ' + toString(other));
  return ValueTimeMark__minus_impl_f87sko_1($this, other.reading_1);
}
function ValueTimeMark__minus_impl_f87sko_1($this, other) {
  return MonotonicTimeSource_getInstance().differenceBetween_jd3lpt_k$($this, other);
}
function ValueTimeMark__toString_impl_ow3ax6($this) {
  return 'ValueTimeMark(reading=' + toString($this) + ')';
}
function ValueTimeMark__hashCode_impl_oduu93($this) {
  return hashCode($this);
}
function ValueTimeMark__equals_impl_uc54jh($this, other) {
  if (!(other instanceof ValueTimeMark()))
    return false;
  var tmp0_other_with_cast = other.reading_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function ValueTimeMark__compareTo_impl_uoccns($this, other) {
  return $this.compareTo_uxrtj9_k$((!(other == null) ? isInterface(other, ComparableTimeMark()) : false) ? other : THROW_CCE());
}
var ValueTimeMarkClass;
function ValueTimeMark() {
  if (ValueTimeMarkClass === VOID) {
    class $ {
      constructor(reading) {
        this.reading_1 = reading;
      }
      minus_82kdun_k$(other) {
        return ValueTimeMark__minus_impl_f87sko_0(this.reading_1, other);
      }
      toString() {
        return ValueTimeMark__toString_impl_ow3ax6(this.reading_1);
      }
      hashCode() {
        return ValueTimeMark__hashCode_impl_oduu93(this.reading_1);
      }
      equals(other) {
        return ValueTimeMark__equals_impl_uc54jh(this.reading_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ValueTimeMark__compareTo_impl_uoccns(this, other);
      }
    }
    protoOf($).compareTo_uxrtj9_k$ = compareTo;
    initMetadataForClass($, 'ValueTimeMark', VOID, VOID, [ComparableTimeMark()]);
    ValueTimeMarkClass = $;
  }
  return ValueTimeMarkClass;
}
var MonotonicClass;
function Monotonic() {
  if (MonotonicClass === VOID) {
    class $ {
      markNow_ns2ype_k$() {
        return MonotonicTimeSource_getInstance().markNow_ns2ype_k$();
      }
      toString() {
        return toString(MonotonicTimeSource_getInstance());
      }
    }
    initMetadataForObject($, 'Monotonic');
    MonotonicClass = $;
  }
  return MonotonicClass;
}
var Monotonic_instance;
function Monotonic_getInstance() {
  return Monotonic_instance;
}
function compareTo(other) {
  return Duration__compareTo_impl_pchp0f(this.minus_82kdun_k$(other), Companion_getInstance().ZERO_1);
}
var ComparableTimeMarkClass;
function ComparableTimeMark() {
  if (ComparableTimeMarkClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ComparableTimeMark', VOID, VOID, [Comparable()]);
    ComparableTimeMarkClass = $;
  }
  return ComparableTimeMarkClass;
}
//region block: init
Monotonic_instance = new (Monotonic())();
//endregion
//region block: exports
export {
  _ValueTimeMark___init__impl__uyfl2m as _ValueTimeMark___init__impl__uyfl2m19i1bclyoswk,
  ValueTimeMark__elapsedNow_impl_eonqvs as ValueTimeMark__elapsedNow_impl_eonqvs31ikzp5dku7pk,
  ValueTimeMark__minus_impl_f87sko as ValueTimeMark__minus_impl_f87sko2z1nwmc9w7tpq,
  _ValueTimeMark___get_reading__impl__5qz8rd as _ValueTimeMark___get_reading__impl__5qz8rdglikwpj1of27,
  Monotonic_instance as Monotonic_instancewn07e60bp6rj,
  ValueTimeMark as ValueTimeMark3e7hmed1q029a,
};
//endregion

//# sourceMappingURL=TimeSource.mjs.map
